export default __webpack_public_path__ + "static/media/headerAlertIcon.985e5406.svg";